<template lang="html">
    <div class="package">
        <div class="package__head">
            <div class="package__name"><span>{{name}}</span></div>
        </div>
        <div class="package__body">
            <div class="package__price header-2">
                {{price}} <i class="fas fa-coins"></i>
            </div>
            <div class="package__services header-4">{{appointments}} ședinte</div>
        </div>
        <div class="package__footer" v-if="$store.state.user.user.role == 'client'" >
            <button class="package__button" type="button" @click="$emit('choose')">Cumpară</button>
            <div class="package__discount">
                {{description}}
            </div>
        </div>
        <div v-else class="package__discount--specialist-page">
            {{description}}
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            name: {
                type: String,
                default: ''
            },
            servicePrice: {
                type: Number,
                default: 0
            },
            appointments: {
                type: Number,
                default: 0
            },
            discount: {
                type: Number,
                default: 0
            },
            description: {
                type: String,
                default: ''
            }
        },
        computed: {
            price() {
                let fullPrice = this.appointments * this.servicePrice;
                return fullPrice - (this.discount/100*fullPrice);
            }
        }
    }
</script>

<style lang="scss" scoped>
    .package {
        background-color: $color-primary;
        box-sizing: border-box;
        box-shadow: 0px 0px 20px #0000000F;
        color: white;
        min-width: 215px;
        max-width: 215px;
        padding: 20px;

        &--last {
            margin: 0px;
        }

        &__head {
            border-bottom: 2px solid white;
        }

        &__name {
            font-size: 16px;
            font-weight: 700;
            margin-bottom: 15px;

            span{
                text-transform: uppercase;
            }
        }

        &__body {}

        &__price {
            color: $color-warning;
            margin-top: 25px;
            font-weight: 500;
            line-height: 21px;
        }

        &__services {
            margin-top: 10px;
        }

        &__button {
            border-radius: 17.5px;
            border: none;
            cursor: pointer;
            color: $color-primary;
            font-family: 'DIN Pro', sans-serif;
            font-size: 14px;
            font-weight: 500;
            height: 35px;
            margin: 25px auto 15px auto;
            outline: none;
            transition: all 0.2s ease;
            width: 100%;
            background: white;

            &:hover {
                background-color: $color-primary;
                border: 2px solid white;
                color: white;
            }
        }

        &__discount {
            text-align: center;
            font-size: 14px;
            opacity: .6;

            &--specialist-page {
                text-align: left;
                margin-top: 10px;
            }
        }

        &__footer {
            // display: flex;
            // flex-direction: ;
        }
    }
</style>